import {useMutation} from "@tanstack/react-query";
import {recoverObsoleteCustomerOfferMutationOptions} from "./recover-obsolete-customer-offer.mutation-options";

export function useRecoverObsoleteCustomerOffer() {
  return useMutation(recoverObsoleteCustomerOfferMutationOptions());
}
